module.exports = __webpack_public_path__ + "img/logo1.463f88a3.png";